module.exports = __webpack_public_path__ + "static/media/creditcard_chip.b36c5e96.svg";